import {
    Route,
    Routes,
} from "react-router-dom";
import "react-sliding-pane/dist/react-sliding-pane.css";
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Admin from "./Admin";
import ScrollToTop from "helper/my-com/ScrollToTop";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const App = () => {
    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route path={`/admin/*`} element={<Admin />} />
            </Routes>
            <ToastContainer />
        </>
    );
};

export default App;
